import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bidi-left-panel',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.scss']
})
export class LeftPanelComponent {
  @Input() active = false;
  @Output() close = new EventEmitter<void>();

  closePanel (e: Event) {
    e.preventDefault();
    this.close.emit();
  }
}
